import React, { useState, useEffect } from 'react'
import Header from '../general/Header';
import SubHeader from '../general/SubHeader';
import BottomBanner from '../general/BottomBanner';
import ResponseMsg from '../general/ResponseMsg';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import 'swiper/css';
import '../css/components/OrderHistory.css';
import Delivery3 from '../assets/delivery2.gif';
import { useNavigate } from 'react-router-dom';

const OrderHistory = ({ isUser, userData }) => {
  const [orders, setOrders] = useState([]);
  const [exchange, setExchange] = useState([]);
  const [showCancelDialog, setShowCancelDialog] = useState(false);
  const [showReorderDialog, setShowReorderDialog] = useState(false);
  const [showDeliveryDialog, setShowDeliveryDialog] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState();
  const [response, setResponse] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [showInvoice, setShowInvoice] = useState(false);
  const [delivery, setDelivery] = useState([]);
  const [excDelivery, setExcDelivery] = useState([]);
  const [orderAddress, setOrderAddress] = useState('');
  const [showExchange, setShowExchange] = useState(false);
const [selectedExchange, setSelectedExchange] = useState(null);

const navigate = useNavigate();
const getToday = () => {
  const today = new Date();
  return today.toISOString().split("T")[0];
};


    const fetchOrders = async () => {
      try {
        const response = await fetch(`https://api.kcmstore.in/store/get-order/${userData.id}`);
        if (response.ok) {
          const data = await response.json();
          const sortedProducts = data.sort((a, b) => b.id - a.id);
          console.log(sortedProducts);
          setOrders(sortedProducts);
        } else {
          console.error('Failed to fetch products');
        }
      } catch (error) {
        console.error('Error fetching products:', error);
      }
    };

  useEffect(() => {

// const fetchOrders = async () => {
//   console.log(startDate, endDate);
//     try {
//       const response = await fetch(
//         `https://api.kcmstore.in/store/get-orders?startDate=${startDate}&endDate=${endDate}`
//       );
//       if (response.ok) {
//         const data = await response.json();
//         const sortedOrders = data.sort((a, b) => b.id - a.id);
//         setOrders(sortedOrders);
//       } else {
//         console.error("Failed to fetch orders");
//       }
//     } catch (error) {
//       console.error("Error fetching orders:", error);
//     }
//   };

    const fetchExchange = async () => {
      try {
        const response = await fetch(`https://api.kcmstore.in/store/get-exchange-order/${userData.id}`);
        if (response.ok) {
          const data = await response.json();
          const sortedProducts = data.sort((a, b) => b.id - a.id);
          setExchange(sortedProducts);
          console.log(exchange);
        } else {
          console.error('Failed to fetch exchange');
        }
      } catch (error) {
        console.error('Error fetching exchange:', error);
      }
    };

    fetchOrders();
    fetchExchange();
  }, []);

    const fetchDelivery = async (orderId) => {
      try {
        const response = await fetch(`https://api.kcmstore.in/store/track-order-delivery/${orderId}`);
        if (response.ok) {
          const data = await response.json();
          console.log(data);
          setDelivery(data);
        } else {
          console.error('Failed to track delivery');
        }
      } catch (error) {
        console.error('Error tracking delivery:', error);
      }
    };


        const fetchExcDelivery = async (orderId) => {
      try {
        const response = await fetch(`https://api.kcmstore.in/store/track-exchange-order-delivery/${orderId}`);
        if (response.ok) {
          const data = await response.json();
          setExcDelivery(data);
        } else {
          console.error('Failed to track delivery');
        }
      } catch (error) {
        console.error('Error tracking delivery:', error);
      }
    };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  };


  const handleCancelDialog = (order) => {
    setSelectedOrder(order);
    setShowCancelDialog(true);
  }


  const handleDelivery = (order) => {
    setSelectedOrder(order);
    fetchDelivery(order.id);
    setShowDeliveryDialog(true);
  }


  const handleCancelOrder = async (orderId) => {
    try {
      const response = await fetch(`https://api.kcmstore.in/store/cancel-order/${orderId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ order_status: 'Cancelled' }),
      });

      if (response.status == 200) {
        setResponse('Your order has been cancelled.');
        setShowCancelDialog(false);
        setTimeout(() => {
          setResponse('');
        }, 2000);
        const updatedOrders = orders.map(order =>
          order.id === orderId ? { ...order, order_status: 'Cancelled' } : order
        );
        setOrders(updatedOrders);
      } else {
        setResponse('Failed to cancel order');
        setTimeout(() => {
          setResponse('');
        }, 2000);
      }
    } catch (error) {
      console.error('Error canceling order:', error);
    }
  };

  const handleShowInvoice = (order) => {
    setSelectedOrder(order);
    setShowInvoice(true);
  }

  const filteredOrders = orders.filter(order => {
    const orderItems = JSON.parse(order.order_items);

    const isDateMatch = formatDate(order.order_date).toLowerCase().includes(searchQuery.toLowerCase());
    const isStatusMatch = order.order_status.toLowerCase().includes(searchQuery.toLowerCase());
    const isProductNameMatch = orderItems.some(orderItem =>
      orderItem.product_name.toLowerCase().includes(searchQuery.toLowerCase())
    );
    return isProductNameMatch || isDateMatch || isStatusMatch;
  });

  const handlePrint = () => {
    setTimeout(() => {
      window.print();
    }, 200);
  };
    

  const getOrderLocation = async (lat, lon) => {
    try {
        const response = await fetch(`https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lon}&format=json`);
        const data = await response.json();

        return data.display_name || 'Unknown location';
    } catch (error) {
        console.error('Error fetching order address:', error);
        return 'Failed to fetch location';
    }
};

  useEffect(() => {
    const fetchOrderAddress = async () => {
        if (selectedOrder?.lat && selectedOrder?.longi) {
            const address = await getOrderLocation(selectedOrder.lat, selectedOrder.longi);
            setOrderAddress(address);
        } else {
            setOrderAddress(`${userData.location || userData.address}, ${userData.city}, ${userData.state}, ${userData.pincode}`);
        }
    };

    fetchOrderAddress();
}, [selectedOrder]);


const handleExchangeReq = (order) => {
  navigate('/exchange-order', {
    state: { order }
  });
};


  const resetCart = async () => {
    try {
      await fetch(`https://api.kcmstore.in/store/clear-cart/${userData.id}`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
      });
    } catch (err) {
      console.error("⚠️ Failed to clear backend cart:", err);
    }

    window.dispatchEvent(new Event('cartUpdated'));
  };



const handlePlaceOrder = async (orderItems) => {
  if (!isUser) {
    setResponse("Please log in to place an order.");
    return;
  }

  const items = JSON.parse(orderItems);
  await resetCart();

  try {
    for (const item of items) {
      const response = await fetch(
        `https://api.kcmstore.in/store/add-to-cart/${userData.id}`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            prod_name: item.product_name,
            item_qty: 1,
          }),
        }
      );

      const data = await response.json();

      if (response.ok) {

        setResponse('Items Added in Cart. Proceed to Checkout');
        navigate('/checkout');
        setTimeout(() => {
          setResponse('');
        }, 2000);
            } else {
        console.error('❌ Failed:', item.name, data.message);
      }
    }

    setResponse('Products added to cart.');
    setShowReorderDialog(false);
    setTimeout(() => setResponse(''), 1000);

  } catch (error) {
    console.error('⚠️ Error while adding items:', error);
  }
};



  return (
    <>
      <Header isUser={isUser} userData={userData} />
      <SubHeader message="Order History" />

      <section className='my-5'>
        <div className='container'>

          <div className="text-start mb-4">
            <input
              type="text"
              className="form-input rounded border-0 bg-light"
              placeholder="🎯 Search order here..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>


          {filteredOrders.length > 0 ? (
            filteredOrders.map((order) => {
              const orderItems = JSON.parse(order.order_items);
              return (
                <div className='my-3' key={order.id}>
                  <div className='order-area'>
                    <p className='fw-semibold'>Order Id #{order.id} placed on {formatDate(order.order_date)}</p>
{order.order_status !== 'Cancelled' && (() => {
  const existingExchange = exchange.find(ex => ex.order_id == order.id);

  if (existingExchange) {
    return (
      <div className='text-end'>
      <button className='text-success para-text fw-semibold order-btn px-2' onClick={() => {
    setSelectedExchange(existingExchange);
    setShowExchange(true);
if (
  existingExchange.req_status != "Exchange Initiated" &&
  existingExchange.req_status != "Exchange Shipped" &&
  existingExchange.req_status != "Cancelled"
) {
  fetchExcDelivery(existingExchange.id);
}
  }}>
        Exchange Status: {existingExchange.req_status}
      </button></div>
    );
  }
})()}
                    <Swiper spaceBetween={20} slidesPerView={6} modules={[Navigation]} loop={true}
                      navigation={{ nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }}
                      breakpoints={{
                        0: {
                          slidesPerView: 3,
                        },
                        768: {
                          slidesPerView: 4,
                        },
                        992: {
                          slidesPerView: 6,
                        }
                      }}>
                        {orderItems.length > 0 ? (
                        orderItems.map((item, index) => (
                          <>
                            {/* <hr /> */}
                            <SwiperSlide key={index} className='my-2'>
                              <img
                                src={`https://api.kcmstore.in/sUploads/${item.image.split(',')[0]}`}
                                className='img-fluid'
                                alt='Order'
                              />
                            
                            </SwiperSlide>
                          </>
                        ))
                      ) : (
                        <p>No items in this order</p>
                      )}
                    </Swiper>
                    <p className='text-muted fw-semibold mb-0 mt-3'>Order Total ₹ {order.total_amount}<br />Your Order has been {order.order_status}</p>

                        <div className='d-flex mt-3'>
{/* {order.order_status == 'Delivered' && (() => {
  const existingExchange = exchange.find(ex => ex.order_id == order.id);

  if (!existingExchange) {
                                                  <button className='order-btn w-100' onClick={() => handleExchangeReq(order)}> Request Exchange ✔</button>  }
  }
            )}  */}

                        <button className='order-btn w-100' onClick={() => handleShowInvoice(order)}>Order Invoice 📃</button>&nbsp;&nbsp;
                    {order.order_status === 'Cancelled' ? '' :
  <>
    {order.payment_mode == 'Cash on Delivery' && order.order_status === 'Confirmed' && (
      <>
        <button className='order-btn w-100' onClick={() => handleCancelDialog(order)}>
          Cancel Order ❌
        </button>
        &nbsp;&nbsp;
      </>
    )}

    {(order.order_status !== 'Confirmed' && order.order_status !== 'Delivered') && (
      <>
        <button className='order-btn w-100' onClick={() => handleDelivery(order)}>
          Track Delivery 🚛
        </button>
        &nbsp;&nbsp;
      </>
    )}
  </>
}   

{order.order_status == 'Delivered' &&
<button className='order-btn w-100' onClick={() => {setSelectedOrder(order); setShowReorderDialog(true)}}>
          Re Order ⏳        </button>}

 {/* {order.order_status === 'Cancelled' ? '' :
                        <>
                          {order.order_status === 'Confirmed' ? <><button className='order-btn w-100' onClick={() => handleCancelDialog(order)}>Cancel Order ❌</button>&nbsp;&nbsp;</> : ''}
                          {order.order_status != 'Confirmed' || order.order_status == 'Delivered' ? <><button className='order-btn w-100' onClick={() => handleDelivery(order)}>Track Delivery 🚛</button>&nbsp;&nbsp;</> : ''}
                          </>
                        } */}
                        </div>
                        {/* flex ends */}
                  </div>
                </div>
              );

            })
          ) : (
            <p>No Orders Placed yet</p>
          )}

        </div>
      </section>

      <BottomBanner />


      {showCancelDialog && (
        <>
          <section className='delete-dialog px-3' onClick={() => setShowCancelDialog(false)}>
            <div className='bg-white col-lg-4 col-md-8 mx-auto px-3 py-3 rounded-4' onClick={(e) => e.stopPropagation()}>
              <p className='featured-category my-4'>Want to Cancel this Order?</p>
              <button className='success-btn' onClick={() => handleCancelOrder(selectedOrder.id)}>Yes</button>&nbsp;&nbsp;
              <button className='danger-btn' onClick={() => setShowCancelDialog(false)}>No</button>
            </div>
          </section>
        </>
      )}

      {showReorderDialog && (
        <>
          <section className='delete-dialog px-3' onClick={() => setShowReorderDialog(false)}>
            <div className='bg-white col-lg-4 col-md-8 mx-auto px-3 py-3 rounded-4' onClick={(e) => e.stopPropagation()}>
              <p className='featured-category my-4'>Add Items of this Order in Cart to Proceed?</p>
              <button className='success-btn' onClick={() => handlePlaceOrder(selectedOrder.order_items)}>Yes</button>&nbsp;&nbsp;
              <button className='danger-btn' onClick={() => setShowReorderDialog(false)}>No</button>
            </div>
          </section>
        </>
      )}


{showDeliveryDialog && (
        <>
          <section className='delete-dialog px-3'>
            <div className='bg-white col-lg-4 col-md-8 mx-auto px-3 py-3 rounded-4 text-start'>
            <p className='sec-heading fs-4'>Track Delivery</p>
            <div className='my-5'>
            <p>Your Order Placed On {formatDate(selectedOrder.order_date)} has been {selectedOrder.order_status}.</p>

{delivery.length > 0 ? (
delivery.map((item, index) => (
  <>
  <p className='fw-semibold'>Delivery Agent Details</p>
  <p className='para-text'>{item.delivery_agent_name} is assigned as your Delivery Agent.<br />You can Contact our agent on {item.delivery_agent_phone}</p>
  <p className='fw-bold text-success'>Order OTP: {item.otp}</p>
  <p>Share OTP with the Delivery agent to receive your Order.</p>
  </>
))
) : ( 
<>
<div className='my-5 text-center px-4'>
<img src={Delivery3} className='profile-img' alt='Delivery Card' />
<p className='para-text mt-2'>Delivery Partner for your Order has not been assigned yet. Our team is working to deliver your order at the earliest.</p></div>
</>
 )}

            </div>
              <button className='login-btn' onClick={() => setShowDeliveryDialog(false)}>Close</button>
            </div>
          </section>
        </>
      )}

      {response && <ResponseMsg message={response} />}


      {showInvoice && selectedOrder && orderAddress && (
        <>
          <section className='invoice-dialog px-2' onClick={() => setShowInvoice(false)}>
            <div className='invoice-dialog-inner animate__animated animate__zoomIn col-lg-8 mx-auto px-lg-5 py-lg-5 px-3 py-3 text-start' onClick={(e) => e.stopPropagation()}>

              <p className='sec-heading fs-4'>Order Invoice</p>

              <div className='invoice-area my-4'>
                <div className='row justify-content-between'>
                  <p className='col-md-8'><span className='fw-semibold'>Customer Details:</span><br />Name: {userData.name}<br />Mobile No: {userData.phone}<br /> 
                  Delivery Address: {orderAddress}</p>
                  <p className='col-md-4'><span className='fw-semibold'>Order Details:</span><br />Order id: {selectedOrder.id}<br />Placed On: {formatDate(selectedOrder.order_date)}</p>
                </div>
                {/* flex ends */}
                <hr />

                <div className='table-responsive'>
                  <table className='w-100'>
                    <tr>
                      <th className='px-2 py-2'>Product</th>
                    <th className='px-2 py-2'>MRP ₹</th>
                      <th className='px-2 py-2'>Qty</th>
                    <th className='px-2 py-2'>Discount</th>
                    <th className='px-2 py-2'>Total ₹</th>
                    </tr>

                    {typeof selectedOrder.order_items === 'string' ? (
                      (() => {
                        try {
                          const parsedItems = JSON.parse(selectedOrder.order_items);
                          if (Array.isArray(parsedItems)) {
                            return parsedItems.map((item, index) => (
                              <tr key={index}>
                                <td className='px-2 py-2'>{item.product_name}</td>
                      <td className='px-2 py-2'>{item.org_price}</td>
                                <td className='px-2 py-2'>{item.quantity}</td>
                      <td className='px-2 py-2'>{item.discount_type == 'amount' ? '₹' : ''} {item.discount_amount} {item.discount_type == 'percent' ? '%' : ''}</td>
                                <td className='px-2 py-2'>{item.product_price * item.quantity}</td>
                                </tr>
                            ));
                          }
                        } catch (error) {
                          return <p>Failed to get items.</p>
                        }
                      })()
                    ) : (
                      <p>No items available.</p>
                    )}

                  </table>
                </div>
                {/* table area */}

                <hr />

{selectedOrder?.order_items && (() => {
  try {
    const items = JSON.parse(selectedOrder.order_items);

    // Sum total price
    const total = items.reduce((sum, item) => sum + Number(item.product_price) * Number(item.quantity), 0);

    return (
      <>
      <p className='text-end my-0 para-text'>
        Order Total: ₹{total.toFixed(2)}<br />
        Platform Fee: ₹{selectedOrder?.platform_fee}<br />
        Delivery Charges: ₹{selectedOrder?.delivery_charge}
      </p>
            <p className='text-end my-0 fw-semibold para-text border-top my-2 py-2 border-bottom'>
              Sub Total: ₹{(Number(total) + Number(selectedOrder?.platform_fee) + Number(selectedOrder?.delivery_charge)).toFixed(2)}
</p>
      </>
    );
  } catch {
    return null;
  }
})()}


{selectedOrder?.coupon_applied && (() => {
  try {
    const coupon = JSON.parse(selectedOrder.coupon_applied);
    return (
      <p className='text-end my-0 para-text border-top my-2 py-2 border-bottom'>
        Coupon Applied: {coupon.coupon_code} <br />
        Discount: {coupon.discount_type === 'percent'
          ? `${coupon.discount_amount}%`
          : `₹${coupon.discount_amount}`}
      </p>
    );
  } catch {
    return null;
  }
})()}

           <p>Grand Total: ₹{selectedOrder.total_amount}<br />Payment Mode: {selectedOrder.payment_mode} <br />Payment Status: {selectedOrder.payment_status}</p>
                <p>Your Order has been {selectedOrder.order_status}.</p>

              </div>
              {/* invoice ends */}
              <button className='danger-btn' onClick={() => setShowInvoice(false)}>Close</button>&nbsp;&nbsp;
              <button className='success-btn' onClick={handlePrint}>Download</button>


            </div>
          </section>
        </>
      )}

{showExchange && selectedExchange && (
  <section className='delete-dialog px-3 py-5'>
    <div className='bg-white col-lg-5 col-md-8 mx-auto px-4 py-4 rounded-4 text-start'>
      <p className='sec-heading fs-4'>Exchange Details</p>

      <div className='my-4'>
        <p><strong>Request ID:</strong> {selectedExchange.id}<br /><strong>Initiated On:</strong> {formatDate(selectedExchange.req_on)}
        <br /><strong>Request Status:</strong> <span className='text-capitalize'>{selectedExchange.req_status}</span></p>
        <p><strong>Order ID:</strong> {selectedExchange.order_id}</p>

        {selectedExchange.ex_items && (
          <>
            <p className='fw-semibold mt-3'>Exchange Items:</p>
            {JSON.parse(selectedExchange.ex_items).map((item, index) => (
              <div key={index}>
                <p className='para-text mb-1'>• {item.name} (Qty: {item.qty}) x ₹{item.price} = ₹{item.total_price}</p>
              </div>
            ))}
          </>
        )}

 {selectedExchange.attachment && selectedExchange.attachment.trim() !== '' && (
  <>
    <p className="mb-2 para-text fw-bold">Attachments Added:</p>
    <div className="d-flex flex-wrap gap-2 mb-2">
      {selectedExchange.attachment
        .split(',')
        .map((img, i) => (
          <img
            key={i}
            src={`https://api.kcmstore.in/sUploads/${img.trim()}`}
            alt={`Attachment ${i + 1}`}
            style={{
              width: 80,
              height: 80,
              borderRadius: 5,
              objectFit: 'cover',
            }}
          />
        ))}
    </div>
  </>
)}
        
{excDelivery.length > 0 ? (
excDelivery.map((item, index) => (
  <>
  <p className='fw-semibold'>Delivery Agent Details</p>
  <p className='para-text'>{item.delivery_agent_name} is assigned as your Delivery Agent.<br />You can Contact our agent on {item.delivery_agent_phone}</p>
  <p className='fw-bold text-success'>Order OTP: {item.otp}</p>
  <p>Share OTP with the Delivery agent to receive your Order.</p>
  </>
))
) : ( 
<>
<div className='my-5 text-center px-4'>
<img src={Delivery3} className='profile-img' alt='Delivery Card' />
<p className='para-text mt-2'>Delivery Partner for your Order has not been assigned yet. Our team is working to deliver your order at the earliest.</p></div>
</>
 )}


      </div>

      <button className='login-btn' onClick={() => setShowExchange(false)}>Close</button>
    </div>
  </section>
)}


    </>
  )
}

export default OrderHistory
